const auTimeZones = [
  'Australia/ACT',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Broken_Hill',
  'Australia/Currie',
  'Australia/Darwin',
  'Australia/Eucla',
  'Australia/Hobart',
  'Australia/LHI',
  'Australia/Lindeman',
  'Australia/Melbourne',
  'Australia/Perth',
].map((value) => ({
  label: value,
  value: value,
}));

export default auTimeZones;
